import React, { useState, useEffect } from "react";
import { Row, Col, Card, message, Divider, Select, Typography, Space, Button } from "antd";
import { DownloadOutlined, UserOutlined } from "@ant-design/icons";
import { HeaderPage } from "../../../components/headerPage";
import { HeaderTitle } from "../../../components/headerTitle";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import http from "../../../services/http";
import { TableCustom } from "../../../components/table";
import { parseToInt } from "../../../helpers/masks";
const { Text } = Typography;

export const EleicoesCipaResultados = ({ to }) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const id_eleicoes_localidades = searchParams.get("id_eleicoes_localidades");
  const navigate = useNavigate();
  const { id_eleicoes } = useParams();
  const [loading, setLoading] = useState(false);
  const [dados, setDados] = useState([]);
  const [eleicao, setEleicao] = useState({});
  const [eleicoesLocalidades, setEleicoesLocalidades] = useState([]);

  useEffect(() => {
    if (!!id_eleicoes) {
      listarEleicoesLocalidades(id_eleicoes);
      carregarEleicao(id_eleicoes);
    }
  }, [id_eleicoes]);

  useEffect(() => {
    if (!!id_eleicoes && !!id_eleicoes_localidades) {
      listarCandidatos(id_eleicoes, id_eleicoes_localidades);
    }
  }, [id_eleicoes, id_eleicoes_localidades]);

  // CARREGAR ELEIÇÃO
  const carregarEleicao = async (id) => {
    if (!id) return;
    setLoading(true);
    const api = await http("get", `v1/eleicoes_cipa_eleicoes/carregar/${id}`, []);
    if (api.statusCode === 200) {
      if (api?.response?.data) setEleicao(api.response.data);
    } else {
      message.error(api.response.message);
      navigate(to);
    }
    setLoading(false);
  };

  // LISTAR ELEICOES LOCALIDADES
  const listarEleicoesLocalidades = async (id) => {
    const api = await http("get", `v1/eleicoes_cipa_eleicoes_localidades/listar/${id}`, []);
    if (api.statusCode === 200) {
      const response = api?.response?.data;
      let array = [];
      if (!!response) {
        for (let e of response) {
          array.push({
            value: e.id,
            label: e.localidade,
          });
        }
      }
      setEleicoesLocalidades(array);
    } else {
      message.error(api.response.message);
    }
  };

  // LISTAR
  const listarCandidatos = async (id, id_eleicoes_localidades) => {
    setLoading(true);
    const api = await http(
      "get",
      `v1/eleicoes_cipa_candidatos/listar_resultados/${id}?id_eleicoes_localidades=${id_eleicoes_localidades}`,
      []
    );
    if (api.statusCode === 200) {
      const response = api?.response?.data;
      setDados(response);
    } else {
      message.error(api.response.message);
    }
    setLoading(false);
  };

  // BAIXAR RELATÓRIO
  const gerarRelatorio = async (id) => {
    if (!id) return;
    setLoading(true);
    const api = await http("file", `v1/eleicoes_cipa_eleicoes/gerar_relatorio/${id}`, []);

    if (api.statusCode === 200) {
      // DOWNLOAD FILE
      const url = window.URL.createObjectURL(api?.response?.data);
      let a = document.createElement("a");
      a.href = url;
      a.download = "relatorio.pdf";
      a.click();
    } else {
      message.error(api.response.message);
    }
    setLoading(false);
  };

  // BAIXAR RELATÓRIO PRESENÇA
  const gerarRelatorioPresenca = async (id) => {
    if (!id) return;
    setLoading(true);
    const api = await http("file", `v1/eleicoes_cipa_eleicoes/gerar_relatorio_presenca/${id}`, []);

    if (api.statusCode === 200) {
      // DOWNLOAD FILE
      const url = window.URL.createObjectURL(api?.response?.data);
      let a = document.createElement("a");
      a.href = url;
      a.download = "relatorio_presenca.pdf";
      a.click();
    } else {
      message.error(api.response.message);
    }
    setLoading(false);
  };

  // COLUNAS TABLE
  const columns = [
    {
      title: "Candidato",
      dataIndex: "nome",
    },
    {
      title: "Votos",
      dataIndex: "votos",
      width: 100,
    },
  ];

  return (
    <Row align="middle" justify="center" className="content-row">
      <Col span={24} align="middle" justify="center">
        <Col xs={24} sm={24} md={22} lg={22} xl={20} xxl={16} align="left">
          <div className="content-item">
            <HeaderPage title="Eleições CIPA" onClickBack={() => navigate(to)} />
            <HeaderTitle
              title={["Eleições", "Resultados"]}
              subtitle={eleicao?.descricao ?? ""}
              icon={<UserOutlined />}
              loading={loading}
            />
            <Divider />
            <Card bordered={false} bodyStyle={{ padding: "3%" }}>
              <TableCustom
                extraHeaderComponents={
                  <>
                    <Space direction="vertical" size={0}>
                      <Text style={{ fontSize: 12 }} type="secondary">
                        Localidade:
                      </Text>
                      <Select
                        placeholder="Selecione a localidade"
                        style={{ minWidth: 200 }}
                        value={!!id_eleicoes_localidades ? parseToInt(id_eleicoes_localidades) : null}
                        disabled={loading}
                        options={eleicoesLocalidades}
                        onChange={(val) =>
                          setSearchParams((state) => {
                            state.set("id_eleicoes_localidades", val);
                            return state;
                          })
                        }
                      />
                    </Space>
                    <Button onClick={() => gerarRelatorio(eleicao?.id)} icon={<DownloadOutlined />}>
                      Baixar
                    </Button>
                    <Button onClick={() => gerarRelatorioPresenca(eleicao?.id)} icon={<DownloadOutlined />}>
                      Lista de Presença
                    </Button>
                  </>
                }
                loading={loading}
                columns={columns}
                dataSource={dados}
              />
            </Card>
          </div>
        </Col>
      </Col>
    </Row>
  );
};
